import { IconProps } from './IconProps';

export const LinkWhite = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>noun-link-4813247</title>
      <g
        id="Experts-section"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Experts-full-page"
          transform="translate(-446.000000, -423.000000)"
          fill="#FFFFFF"
          fillRule="nonzero"
        >
          <g id="Group-2-Copy" transform="translate(350.000000, 423.000000)">
            <g
              id="noun-link-4813247"
              transform="translate(96.000000, 0.000000)"
            >
              <path
                d="M5.55715244,7.40299245 C6.3632225,6.58461598 7.72282478,6.52898073 8.5968365,7.40299245 L8.60298861,7.40299245 C8.84907292,7.64907677 9.02763312,7.95066447 9.132201,8.27059459 C9.39058807,8.22752946 9.61834095,8.11679372 9.79063074,7.9445369 L10.6397732,7.1015476 C10.4490605,6.73242845 10.2028223,6.39392884 9.90754166,6.09245834 C8.29269119,4.51064473 5.79661363,4.55499909 4.24659159,6.09245834 L1.16998828,9.16906164 C-0.390069347,10.7418286 -0.389922842,13.2572814 1.16998828,14.8300117 C2.74275522,16.3900693 5.25820805,16.3899228 6.83093836,14.8300117 L9.7291353,11.9318148 C8.88299614,12.0694488 8.07066299,11.9920466 7.31711493,11.7287956 L5.52041523,13.5193421 C4.70819196,14.3377186 3.29295444,14.3377186 2.47457796,13.5193421 C1.63675296,12.6816636 1.63748548,11.3167505 2.47457796,10.479658 C2.5359562,10.4181369 5.7629175,7.1977647 5.55718797,7.40305472 L5.55715244,7.40299245 Z"
                id="Path"
              ></path>
              <path
                d="M10.4430915,8.59700755 C9.64647099,9.40549494 8.28844365,9.48189726 7.40340743,8.59700755 L7.39725532,8.59700755 C7.15117101,8.35092323 6.97261081,8.04933553 6.86804293,7.72940541 C6.60965586,7.77247054 6.38190298,7.88320628 6.2096132,8.0554631 L5.36047068,8.8984524 C5.55118346,9.26757155 5.79742161,9.60607116 6.09270227,9.90754166 C7.7228625,11.5045185 10.2182808,11.4302405 11.7536523,9.90754166 L14.8302556,6.83093836 C16.3903133,5.25817143 16.3901668,2.74271859 14.8302556,1.16998828 C13.2574887,-0.390069347 10.7420359,-0.389922842 9.16930557,1.16998828 L6.27125514,4.06818522 C7.1173943,3.93055117 7.92972745,4.00795339 8.6832755,4.27120441 L10.4799752,2.48065792 C11.2921985,1.66228144 12.707436,1.66228144 13.5258125,2.48065792 C14.3636375,3.31833642 14.362905,4.6832495 13.5258125,5.52034198 C13.4642914,5.58186306 10.2373264,8.8022353 10.443056,8.59694528 L10.4430915,8.59700755 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

